export default __webpack_public_path__ + "static/media/map-pin.ca534a45.svg";